import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    content: 'space-y-2 lg:(p-6 -m-6)',
    contentContainer: 'relative w-full flex md:(pl-5 pointer-events-none) pb-6',
    contentCtaContainer: 'gap-4 lg:gap-6 <md:w-full'
  },
} satisfies RecursivePartial<CMSConfig['hero']>
